import React, { useEffect, useState } from 'react';

type Theme = 'neon-dark' | 'editorial-fantasy';

interface ThemeSelectorProps {
  onThemeChange?: (theme: Theme) => void;
}

export function ThemeSelector({ onThemeChange }: ThemeSelectorProps) {
  const [currentTheme, setCurrentTheme] = useState<Theme>('editorial-fantasy');

  // Initialize theme from localStorage or system preference
  useEffect(() => {
    const stored = localStorage.getItem('theme') as Theme | null;
    const theme = stored || 'editorial-fantasy';
    setCurrentTheme(theme);
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, []);

  const applyTheme = (theme: Theme) => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
    if (onThemeChange) {
      onThemeChange(theme);
    }
  };

  const handleThemeChange = (theme: Theme) => {
    setCurrentTheme(theme);
    applyTheme(theme);
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: '1.5rem',
      right: '1.5rem',
      zIndex: 9999,
      display: 'flex',
      gap: '0.75rem',
      padding: '0.75rem',
      backgroundColor: 'var(--color-surface-1)',
      border: '1px solid var(--color-border)',
      borderRadius: '0.5rem',
      backdropFilter: 'blur(4px)',
    }}>
      <button
        onClick={() => handleThemeChange('neon-dark')}
        style={{
          padding: '0.5rem 1rem',
          backgroundColor: currentTheme === 'neon-dark' ? 'var(--color-primary)' : 'transparent',
          color: currentTheme === 'neon-dark' ? '#000' : 'var(--color-text-secondary)',
          border: '1px solid var(--color-border)',
          borderRadius: '0.25rem',
          cursor: 'pointer',
          fontSize: '0.85rem',
          fontWeight: 500,
          transition: 'all var(--transition-fast)',
        }}
        title="Neon Dark theme"
      >
        Neon
      </button>

      <button
        onClick={() => handleThemeChange('editorial-fantasy')}
        style={{
          padding: '0.5rem 1rem',
          backgroundColor: currentTheme === 'editorial-fantasy' ? 'var(--color-primary)' : 'transparent',
          color: currentTheme === 'editorial-fantasy' ? '#000' : 'var(--color-text-secondary)',
          border: '1px solid var(--color-border)',
          borderRadius: '0.25rem',
          cursor: 'pointer',
          fontSize: '0.85rem',
          fontWeight: 500,
          transition: 'all var(--transition-fast)',
        }}
        title="Editorial Fantasy theme"
      >
        Editorial
      </button>
    </div>
  );
}
